import { sampleSize } from 'lodash';
import Definition from '@src/icons/prompt/definitions.svg';
import Analysis from '@src/icons/prompt/analysis.svg';
import Capability from '@src/icons/prompt/capabilities.svg';
import BestPractice from '@src/icons/prompt/best-practices.svg';

export const CATEGORY_ICON_MAP = {
  Definitions: Definition,
  'Best Practices': BestPractice,
  // Roles,
  Analysis,
  Capabilities: Capability,
};

export const NUMBER_OF_QUESTIONS_PER_SECTION = 3;

export const NUMBER_OF_QUESTIONS_IN_WELCOME_PAGE = 3;

export const TIMELINE_SUMMARY_QUESTION = '__From ECO1 Timeline Summary__';

export const QUESTIONS_SECTIONS = [
  {
    title: 'Analysis',
    questions: [
      'I am worried my customers can not watch video. How can I monitor it?',
      'What percent of attempted sessions did not start video playback with an error failure in the last 30 days?',
      'What were the maximum concurrent plays yesterday?',
      'My video kept freezing yesterday. Did other users also experience freezing interruptions?',
      'What is my SPI?',
      'How many active users are using my app?',
      'My customer complained about the app not loading the page. Is this a problem for more users?',
      'Were there any data spikes or performance degradation in Average Network Request Duration?',
    ],
  },
  {
    title: 'Definitions',
    questions: [
      // video domain
      'What is SPI?',
      'What is the meaning of -T in VPF-T?',
      'How can I find the devices that are contributing most to VSF-T?',
      'How do we address unknown CDNs in Pulse?',
      'What is Zero CIRR?',
      'What is the difference between Content Category and Content Type?',
      'How is VST measured?',
      'What are the different time granularities for live, one day, 7 days, or more?',
      'If sessions are set to "Yes" on Impacted Session column in the Viewer dashboard what does that mean?',
      'Are we able to identify sessions and associated viewer IDs in Pulse?',
      'Do Concurrent Plays include paused time?',
      'What is Abandonment?',
      // app domain
      'What is the difference between App Session Metrics and App Interval Metrics?',
      'What is auto-collected by the App Sensor?',
      'What devices are supported with App Sensor?',
      'What is ECO?',
      'What App metrics are supported?',
      'What is Semantic Mapper for App?',
      'What is App Metric Builder?',
      // ad domain
      'What does "% Slate Duration" indicate in ad analytics and how does it impact ad revenue?',
      'How is "% Slate Plays" different from "% Slate Duration" and what does it tell us about ad performance?',
      'What does "Ads Completed (% of Ad Impressions)" reveal about viewer engagement with ads?',
      'How is "Ad Actual Duration" calculated and what insights does it offer?',
      'What do "Ad Attempts" signify in the context of ad delivery and success rate?',
      'How does "Ad Average Bitrate" affect the quality of ad experience?',
      'What is the significance of "Ad Concurrent Plays" in real-time ad analytics?',
      'How can "Ad Frequency/Unique" help in optimizing ad campaigns for better viewer experience?',
      'What insights can "Ad Impressions (% of Attempts)" provide about ad delivery efficiency?',
      'What does "Ad Rebuffering Ratio" indicate about ad streaming quality and viewer experience?',
    ],
  },
  {
    title: 'Best Practices',
    questions: [
      // video domain
      'How do I improve Video Baseline Performance?',
      'What is Real-Time Monitoring in Conviva for Video?',
      'How can I be alerted automatically for a Video incident or outage? ',
      'How can I benchmark video performance so I know customers are getting the experience they expect?',
      'How can I track New App Version Releases in Video & Media players?',
      'How can I integrate Conviva video instrumentation in a new device?',
      'How do I manage Conviva Device Integrations for Video and Media?',
      // app domain
      'How do I integrate Conviva App Sensor? ',
      'What are the steps for mapping new app events?',
      // ad domain
      'How do I monitor ad performance in real-time using the Ad Experience Dashboard?',
      'What features does the Ad Experience Dashboard offer for analyzing and diagnosing ad performance?',
      'How can I monitor and analyze ad creative performance across different browser versions?',
    ],
  },
  {
    title: 'Capabilities',
    questions: [
      // video domain
      'What are the newest Video features and functionalities?',
      'What are the most important Video metrics?',
      'What are some tips for Video Trends Analytics Workflows?',
      'How does Pulse automatically surface key insights into these datasets?',
      'How does Pulse help me operationalize data across my org through visualization?',
      'How does Pulse enable video and media monitoring in real-time?',
      'How can I see a whole timeline of a video session?',
      'What are the thresholds for Video SPI?',
      'What is CONVIVA_INTERNAL_UNKNOWN?',
      'How do I enable Custom tags as dimensions in Pulse Video Trends?',
      'When I log into Conviva why does it take me to my profile page?',
      'Why are AI Alerts not firing, is there a minimum amount of traffic needed?',
      // app domain
      'How is drill-down analysis performed in ECO?',
      'What insights can be gained from viewing the App User Timeline?',
      'What kind of analytics capabilities are essential in RUM solutions for optimizing app user experience?',
      'How do RUM solutions help in understanding and improving app user engagement? ',
      'What are common use cases for analyzing app user engagement?',
      'What is Real-Time Monitoring in Conviva for App?',
      'How can I be alerted automatically for an App incident or outage?',
      // ad domain
      'How can I navigate through the Ad Experience interface effectively?',
      'What are the key features of the Ad Experience dashboards?',
      'How do I change the default landing page in the Ad Experience interface?',
      'How can I use filters for more focused analysis in the Ad Experience interface?',
      'Is there a way to export data from the Ad Experience dashboards?',

      // Roles part
      // video domain
      'What dashboards and metrics are most important for a Media & Entertainment executive?',
      'What dashboards are most common for a Video Product Lead?',
      'What are typical data-driven techniques for Video Engineering/Ops/IT?',
      'How can Customer Care in Media & Entertainment utilize Conviva?',
      'How can Video Data Science & Analytics Team expand Conviva data utilization?',
      'How do Video App Developers use Conviva?',
      // app domain
      'Who benefits from using ECO?',
      'Who is the typical owner involved in setting up and using Semantic Mapper and Metric Builder for App?',
      'What dashboards and metrics are most important for an App executive?',
      'What are typical data-driven techniques for App Engineering/Ops/IT?',
      // ad domain
      'What are some typical job titles and job functions for users of an Ad Experience dashboard?',
    ],
  },
];

export function getRandomisedQuestions(filteredQuestions, noOfQuestions) {
  return filteredQuestions.map(({ title, questions }) => {
    return {
      title,
      questions: sampleSize(questions, noOfQuestions),
    };
  });
}

export function getBotAnswerText(botData) {
  return (botData || [])
    .filter((item) => item.type === 'markdown')
    .map((item) => item.text)
    .join('');
}

export function botAnswerHasMetricData(botData) {
  return (botData || []).some((item) => item.type === 'metricChart');
}
